export default __webpack_public_path__ + "static/media/placeholderimage.bc4d69a9.png";